import { Component } from '@angular/core';

@Component({
  selector: 'app-api',
  templateUrl: './api.component.html',
  styleUrls: ['./api.component.scss']
})
export class ApiComponent {
  install = `npm i ng-avesta-translate`
  module = `
  import { NgAvestaTranslateModule } from 'ng-avesta-translate'"

    @NgModule({
        declarations: [
        AppComponent
        ],
        imports: [
        BrowserModule,
        AppRoutingModule,
       --- NgAvestaTranslateModule ---
        ],
        providers: [],
        bootstrap: [AppComponent]
        })
        export class AppModule { }`

  app = `
  import { Component } from '@angular/core';

  import { NgAvestaTranslateService } from 'ng-avesta-translate';
  @Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
   constructor(public NgAvestaTranslate: NgAvestaTranslateService) {
    this.NgAvestaTranslate.login('{{Key Api}}', '{{Key User}}')

  }

}`

  useapp = `
  example คือคำศัพท์ | translate คือ function สำหรับแปลภาษา
  <p>{{'example' | translate}}</p>
`
}


